import * as React from "react";

export interface IconProps {
  name: string;
  color?: string;
  fontSize?: string | number;
  className?: string;
}
const MyIcon: React.FC<IconProps> = ({
  name,
  className,
  color = "inherit",
  fontSize = "inherit",
}) => {
  return (
    <span
      className={`material-icons material-icons-round ${className}`}
      style={{ fontSize, color }}
    >
      {name}
    </span>
  );
};

export default MyIcon;
